export default __webpack_public_path__ + "static/media/education_title.39d366e4.svg";